import React from 'react';
import { motion } from 'framer-motion';
const trackInitiateCheckout = (value: number, contentName: string) => {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', 'InitiateCheckout', {
      value,
      currency: 'ARS',
      content_name: contentName
    });
  }
};
export function Pricing() {
  return <section className="py-16 bg-transparent" id="comprar" data-id="element-180">
      <div className="container mx-auto px-4" data-id="element-181">
        <div className="text-center mb-10" data-id="element-182">
          <h2 className="text-3xl md:text-4xl font-black text-black uppercase tracking-tight" data-id="element-183">
            ELEGÍ TU SISTEMA
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto items-stretch" data-id="element-184">
          {/* Card 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl p-6 border-2 border-slate-200 flex flex-col" data-id="element-185">
            <div className="text-3xl mb-3" data-id="element-186">📘</div>
            <h3 className="text-xl font-black text-black uppercase mb-1" data-id="element-187">
              Sistema 12 Semanas (PDF)
            </h3>
            <p className="text-blue-600 font-bold text-sm mb-4" data-id="element-188">
              3 Tomos + Bonos
            </p>
            <div className="inline-block bg-red-100 text-red-600 font-bold text-xs px-3 py-1 rounded-full mb-4 w-max" data-id="element-189">
              DESCUENTO IMPERDIBLE
            </div>
            <p className="text-slate-500 text-sm mb-6" data-id="element-190">
              Ideal para: hacerlo por tu cuenta, con planillas y método
              completo.
            </p>
            <div className="mt-auto" data-id="element-191">
              <div className="flex items-baseline gap-2 mb-4" data-id="element-192">
                <span className="text-lg text-slate-400 line-through" data-id="element-193">
                  $49.990
                </span>
                <span className="text-4xl font-black text-black" data-id="element-194">$19.999</span>
              </div>
              <a href="https://www.tusoluciondigital.shop/cart/43638879551554:1" onClick={() => trackInitiateCheckout(19999, 'Sistema 12 Semanas')} className="block w-full text-center py-4 bg-green-500 text-black font-black uppercase tracking-wider rounded-full border-2 border-black hover:bg-green-600 hover:-translate-y-1 transition-all duration-300 shadow-lg shadow-green-500/30" data-id="element-195">
                → QUIERO MI SISTEMA 12 SEMANAS
              </a>
            </div>
          </motion.div>

          {/* Card 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-blue-100 rounded-2xl p-6 border-2 border-blue-600 flex flex-col relative shadow-xl" data-id="element-196">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-blue-600 text-white px-4 py-1 rounded-full text-xs font-black uppercase whitespace-nowrap" data-id="element-197">
              ⭐ MÁS ELEGIDO
            </div>
            <div className="text-3xl mb-3" data-id="element-198">🏆</div>
            <h3 className="text-xl font-black text-black uppercase mb-1" data-id="element-199">
              Sistema + Acompañamiento
            </h3>
            <p className="text-blue-600 font-bold text-sm mb-4" data-id="element-200">
              3 Tomos + Bonos + Kit "Sostener"
            </p>
            <p className="text-slate-500 text-sm mb-6" data-id="element-201">
              Ideal para: si sabés que arrancás bien, pero abandonás cuando se
              complica.
            </p>
            <div className="mt-auto" data-id="element-202">
              <div className="flex items-baseline gap-2 mb-4" data-id="element-203">
                <span className="text-lg text-slate-400 line-through" data-id="element-204">
                  $69.990
                </span>
                <span className="text-4xl font-black text-black" data-id="element-205">$29.999</span>
              </div>
              <a href="https://www.tusoluciondigital.shop/cart/43653680300098:1" onClick={() => trackInitiateCheckout(29999, 'Sistema + Acompañamiento')} className="block w-full text-center py-4 bg-green-500 text-black font-black uppercase tracking-wider rounded-full border-2 border-black hover:bg-green-600 hover:-translate-y-1 transition-all duration-300 shadow-lg shadow-green-500/30" data-id="element-206">
                → QUIERO EL SISTEMA + ACOMPAÑAMIENTO
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}